export const LogCollectionGuard = 'GET /log/db';
